import { tw } from "src/design-system/tw";
import Minus from "src/design-system/icons/Minus.svg?react";
import Plus from "src/design-system/icons/Plus.svg?react";
import { useIntl } from "react-intl";
import messages from "../RoomsForm/RoomDetails.messages";

type CountProps = {
  count: number;
  handleAdd: () => void;
  handleSubtract: () => void;
  disablePlus: boolean;
  disableMinus: boolean;
  passengerType: "adult" | "child";
};

export function CounterAddSubtract({
  count,
  handleAdd,
  handleSubtract,
  disablePlus,
  disableMinus,
  passengerType,
}: CountProps) {
  const intl = useIntl();

  return (
    <div className="flex items-center gap-5">
      <button
        className={tw(
          "cursor-pointer rounded-full border-1 border-border-secondary bg-white p-2 focus:outline-2 focus:outline-ring",
          disableMinus && "cursor-not-allowed opacity-50",
        )}
        onClick={handleSubtract}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleSubtract();
          }
        }}
        disabled={disableMinus}
        aria-label={intl.formatMessage(messages[`${passengerType}RemoveLabel`])}
      >
        <Minus />
      </button>
      <span>{count}</span>
      <button
        className={tw(
          "cursor-pointer rounded-full border-1 border-border-secondary bg-white p-2 focus:outline-2 focus:outline-ring",
          disablePlus && "cursor-not-allowed opacity-50",
        )}
        onClick={handleAdd}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleAdd();
          }
        }}
        disabled={disablePlus}
        aria-label={intl.formatMessage(messages[`${passengerType}AddLabel`])}
      >
        <Plus />
      </button>
    </div>
  );
}
